import SelectionForm from '../selection/form_base';

export default class extends SelectionForm {
  static targets = ['submitButton'];

  get _dimensions() {
    return ['board_or_fp_view', 'rationale', 'board_shoppables'];
  }

  get _designItemIdentifier() {
    return 'pdf-export--design-item';
  }

  get _folderItemIdentifier() {
    return 'pdf-export--folder-item';
  }

  _selectionChanged(hasSelection) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !hasSelection;
      this.submitButtonTarget.classList.toggle('button-disabled', !hasSelection);
    }
  }
}
